import { tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { issueStatus } from './consts.js';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
// const validator_EntityReference: ValidatorTypeResolver<OmitDBObject<EntityReference>> = {
// 	entityType: tsValidateValue(allDBTypes),
// 	entityId: tsValidateUniqueId,
// };
const validator_DatabaseIntegrityIssue = {
    // type: tsValidateValue(issueTypes),
    type: tsValidateString(),
    status: tsValidateValue(issueStatus),
    // entityReferences: tsValidateArray(validator_EntityReference),
    issueId: tsValidateString(),
    topicId: tsValidateString(),
};
export const DBDef_DatabaseIntegrityIssue = {
    validator: validator_DatabaseIntegrityIssue,
    entityName: 'entity-reference',
    dbKey: 'entity-references',
    dbGroup: knowledgeManagerDBGroup,
    versions: ['1.0.0'],
};
//# sourceMappingURL=db-def.js.map